import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { DocumentStageClear } from "src/app/domain/models/DocumentStageClear";
import { Operation, OperationAssignDocumentsRead, OperationDocumentGroupByType, OperationInformation, UploadOperationFileRequest } from "src/app/domain/models/Operation";
import { OperationDocument } from "src/app/domain/models/OperationDocument";

Injectable({providedIn: 'root'})
export abstract class OperationGateway {
    abstract uploadFile(uploadRequest: UploadOperationFileRequest): Observable<Operation>
    abstract getByImportOrderId(importOrderId: any): Observable<OperationInformation>
    abstract updateDocument(operationDocument: OperationDocument): Observable<OperationDocument>
    abstract deleteDocument(guid: string): Observable<any>
    abstract getDocumentsByDocumentStage(importOrderId: string, documentStageId: number ): Observable<OperationDocumentGroupByType[]>
    abstract hasPendingViewsStage(operationDocumentTypeId: number, importOrderId: string): Observable<any>
    abstract updateDescription(documentId: string, documentDescription: string, isForwarderDocument: boolean, isQcDocument: boolean, operationDocumentType?: number) : Observable<any>
    abstract getClearStages(importOrderId: string): Observable<DocumentStageClear>
    abstract uploadFileMultiple(files: any[], names: string[], documentTypes: number[], orderId: string): Observable<Operation>
    abstract assignDocumentsRead(request: OperationAssignDocumentsRead): Observable<any>
    abstract downloadDocumentAssignmentReport(exporterId: number, startDate: string, endDate: string): Observable<any>
}
